module.exports = __webpack_public_path__ + "static/img/ll02.373d54a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ll02.png
// module id = CRsO
// module chunks = 0